export const SEARCH_MODAL = 'SEARCH_MODAL';
export const COMPANY_SERVICE_PORTAL_MODAL = 'COMPANY_SERVICE_PORTAL_MODAL';
export const NEWSLETTER_MODAL = 'NEWSLETTER_MODAL';
export const CHAT_AUTHENTICATION_MODAL = 'CHAT_AUTHENTICATION_MODAL';

export const NOTIFICATIONS_MODAL = 'NOTIFICATIONS_MODAL';
export const MY_PROFILE_MODAL = 'MY_PROFILE_MODAL';
export const CHANGE_ADDRESS_MODAL = 'CHANGE_ADDRESS_MODAL';
export const PAYMENT_OPTION_MODAL = 'PAYMENT_OPTION_MODAL';
export const DELIVERY_OPTION_MODAL = 'DELIVERY_OPTION_MODAL';
export const DELIVERY_OPTIONS_MAP_MODAL = 'DELIVERY_OPTIONS_MAP_MODAL';
export const CONFIRMATION = 'CONFIRMATION';
export const ATTACH_FILES_MODAL = 'ATTACH_FILES_MODAL';
export const DONT_HAVE_FILES_MODAL = 'DONT_HAVE_FILES_MODAL';
export const QR_CODE_MODAL = 'QR_CODE_MODAL';
export const BARCODE_MODAL = 'BARCODE_MODAL';
export const SHOW_LOCATION_MODAL = 'SHOW_LOCATION_MODAL';
export const CHANGE_PASSWORD_MODAL = 'CHANGE_PASSWORD_MODAL';
export const PAY_MODAL = 'PAY_MODAL';
export const VERIFY_EMAIL_MODAL = 'VERIFY_EMAIL_MODAL';
export const VERIFY_EMAIL_SECURE_MODAL = 'VERIFY_EMAIL_SECURE_MODAL';
export const VERIFY_PHONE_MODAL = 'VERIFY_PHONE_MODAL';
export const RECIPIENT = 'RECIPIENT';
export const POSTBOXES_STATUS_MODAL = 'POSTBOXES_STATUS_MODAL';
